export function DateFromISO() {
    // Decoding time from ISO string representation
    if (typeof Date.fromISO === "undefined") {
        Date.fromISO = function (date) {
            //2008-05-12T15:28:45.6642211Z - example of server answer
            if (!date) {
                return;
            }
            let arr = date.match(/(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)\.?(\d*)/i);
            if (!arr) {
                return undefined;
            }
            return new Date(parseInt(arr[1], 10), parseInt(arr[2], 10) - 1, parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5], 10), parseInt(arr[6], 10), arr[7] ? parseFloat("0." + arr[7]) * 1000 : 0);
        };
    }
}
//# sourceMappingURL=DateFromISO.js.map